import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const toggleMobileMenu = (e) => {
    if (e.currentTarget.className === 'mobileButton') {
      setMobileOpen(!mobileOpen);
    } else {
      setMobileOpen(false);
    }
  }
  return (
    <header>
      <h1>fwaldal.no</h1>
      <nav className={mobileOpen ? 'mobileOpen' : 'mobileClosed'}>
        <ul>
          <li>
            <NavLink activeClassName='activeNavLink' exact to='/' onClick={toggleMobileMenu}>Home</NavLink>
          </li>
          <div className='menuDivider' />
          <li>
            <NavLink activeClassName='activeNavLink' to='/about' onClick={toggleMobileMenu}>About me</NavLink>
          </li>
          <div className='menuDivider' />
          <li>
            <NavLink activeClassName='activeNavLink' to='/work' onClick={toggleMobileMenu}>My projects</NavLink>
          </li>
          <div className='menuDivider' />
          <li>
            <NavLink activeClassName='activeNavLink' to='/experience' onClick={toggleMobileMenu}>Work and Education</NavLink>
          </li>
        </ul>
      </nav>
      <div className='mobileButton' onClick={toggleMobileMenu}>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </header>
  )
}
